const SizesFoundationsThemes = {
    size_00: '0rem',
    size_25: '0.03125rem',
    size_38: '0.125rem',
    size_50: '0.25rem',
    size_75: '0.375rem',
    size_100: '0.5rem',
    size_125: '0.625rem',
    size_150: '0.75rem',
    size_200: '1rem',
    size_250: '1.25rem',
    size_300: '1.5rem',
    size_325: '1.75rem',
    size_350: '2rem',
    size_375: '2.125rem',
    size_400: '2.5rem',
    size_425: '2.75rem',
    size_450: '3rem',
    size_500: '3.5rem',
    size_550: '4rem',
    size_loader_primary: '4rem',
    size_600: '4.5rem',
    size_650: '5rem',
    size_675: '5.75rem',
    size_700: '6rem',
    size_750: '6.5rem',
    size_800: '7rem',
    size_850: '7.5rem',
    size_900: '8rem',
    size_950: '8.5rem',
    size_975: '8.75rem',
    size_1000: '9rem',
    size_1050: '9.5rem',
    size_1075: '9.75rem',
    size_1088: '10rem',
    size_1089: '10.25rem',
    size_1080: '11.75rem',
    size_1083: '12.125rem',
    size_1091: '12.1875rem',
    size_1100: '12.5rem',
    size_1110: '13rem',
    size_1125: '13.375rem',
    size_1150: '14.875rem',
    size_1175: '14.9375rem',
    size_1176: '15.5rem',
    size_1180: '16.5rem',
    size_1185: '19.5rem',
    size_1200: '20.5rem',
    size_1225: '21.75rem',
    size_1238: '28rem',
    size_1250: '30rem',
    size_1300: '45rem',
};
export { SizesFoundationsThemes };
//# sourceMappingURL=sizes-foundations.themes.js.map